<template>
  <div class="meta-info-container" :class="[{center : center}]">
    <div class="title" :style="titleStyle">{{ title }}</div>
    <div class="content">
      <slot v-if="$i18n.locale !== 'en'" name="zh"></slot>
      <slot v-if="$i18n.locale === 'en'" name="en"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      titleStyle: {
        type: Object,
      },
      title: {
        required: true,
        type: String,
      },
      center: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style scoped>
  .small_head {
  }

  .info_content {
  }

  .meta-info-container {
    margin: 25px 0px 0px 0px;
  }
  
  .meta-info-container.center {
    text-align: center;
  }

  .title {
    font-size: 14px;
  }

  .content {
    font-size: 20px;
    margin-bottom: 8px;    
  }
</style>